import axios from "axios";
import { getUrl } from "../../MIS/Global";

// Base Axios instance
const apiClient = axios.create({
  baseURL: getUrl(),
});

// Helper to build full URL with query params
const buildUrlWithParams = (endpoint, params = {}) => {
  const query = new URLSearchParams(params).toString();
  return query ? `${endpoint}/?${query}` : `${endpoint}/`;
};

// Central request handler
const request = async (method, endpoint, data = {}, config = {}) => {
  const {
    headers = {},
    params = {},             // For GET/DELETE
    contentType = "application/json" //"multipart/form-data",
  } = config;

  const axiosConfig = {
    headers: {
      "Content-Type": contentType,
      ...headers,
    },
  };

  let url = endpoint;

  switch (method) {
    case "post":
      url = `${endpoint}/`;
      return (await apiClient.post(url, data, axiosConfig)).data;

    case "patch":
      url = `${endpoint}/`;
      return (await apiClient.patch(url, data, axiosConfig)).data;

    case "get":
      url = buildUrlWithParams(endpoint, params);
      return (await apiClient.get(url, axiosConfig)).data;

    case "delete":
      url = buildUrlWithParams(endpoint, params);
      return (await apiClient.delete(url, axiosConfig)).data;

    default:
      throw new Error(`Unsupported method: ${method}`);
  }
};

// Exported methods
export const apiAdd = (endpoint, data, config = {}) =>
  request("post", endpoint, data, config);

export const apiUpdate = (endpoint, data, config = {}) =>
  request("patch", endpoint, data, config);

export const apiGet = (endpoint, params = {}, config = {}) =>
  request("get", endpoint, {}, { ...config, params });

export const apiDelete = (endpoint, params = {}, config = {}) =>
  request("delete", endpoint, {}, { ...config, params });
